import { render, staticRenderFns } from "./Complaints.vue?vue&type=template&id=6bbb9244&scoped=true&"
import script from "./Complaints.vue?vue&type=script&lang=js&"
export * from "./Complaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb9244",
  null
  
)

export default component.exports